import React from 'react';
import HeaderMain from '../../components/HeaderMain';

/**
 * Render Home page
 *
 * @component
 */
const Home = () => {
  return (
    <>
      <HeaderMain
        highlightTitle={'SORRY !'}
        subtitle={'Home page is under construction...'}
      />
    </>
  );
};

export default Home;
